import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 10 19" {...props}>
      <title>{props.title || 'Carousel-Arrow-Left'}</title>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-15.000000, -124.000000)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          transform="translate(16.000000, 124.000000)"
          stroke="#FFFFFF"
          strokeWidth="3"
        >
          <polyline points="8 1.5 0 9.5 8 17.5" />
        </g>
      </g>
    </Icon>
  )
}
